import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    data: [],
    loading: false,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    const newData = [...state.data];

    switch (type) {

    case actions.ADMINS_FETCHED:
        return { ...state, data: payload };

    case actions.ADMIN_CREATED:
        newData.push(payload);
        return { ...state, data: newData };

    case actions.ADMIN_DELETED:
        return { ...state, data: newData.filter(c => c.adminId !== payload.adminId) };

    case actions.ADMINS_FETCH_LOADING:
        return { ...state, ...payload };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/admins/admins.reducer.js